/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CorrectionSchema } from './CorrectionSchema';
import {
    CorrectionSchemaFromJSON,
    CorrectionSchemaFromJSONTyped,
    CorrectionSchemaToJSON,
    CorrectionSchemaToJSONTyped,
} from './CorrectionSchema';

/**
 * 
 * @export
 * @interface CorrectionUpsertResponse
 */
export interface CorrectionUpsertResponse {
    /**
     * 
     */
    correction: CorrectionSchema;
}

/**
 * Check if a given object implements the CorrectionUpsertResponse interface.
 */
export function instanceOfCorrectionUpsertResponse(value: object): value is CorrectionUpsertResponse {
    if (!('correction' in value) || value['correction'] === undefined) return false;
    return true;
}

export function CorrectionUpsertResponseFromJSON(json: any): CorrectionUpsertResponse {
    return CorrectionUpsertResponseFromJSONTyped(json, false);
}

export function CorrectionUpsertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectionUpsertResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'correction': CorrectionSchemaFromJSON(json['correction']),
    };
}

export function CorrectionUpsertResponseToJSON(json: any): CorrectionUpsertResponse {
    return CorrectionUpsertResponseToJSONTyped(json, false);
}

export function CorrectionUpsertResponseToJSONTyped(value?: CorrectionUpsertResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correction': CorrectionSchemaToJSON(value['correction']),
    };
}

